























































import {
  Component,
  Prop,
  Vue, Watch,
} from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import UserService from '../services/user.service';
import Dialog from '@/components/Dialog.vue';
import {Role, User} from '@/types';
import GenericButton from '@/components/GenericButton.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';

@Component({
  components: {
    ConfirmButton,
    CancelButton,
    GenericButton,
    Dialog,
  },
})
export default class UserEdit extends Vue {
  @Action private createUserAsync: any;
  @Action private updateUserAsync: any;
  @Action private addRolesAsync: any;
  @Action private addToastErrorMessage: any;

  @Prop() private user!: User;
  @Prop({default: false}) private showUserDialog!: boolean;

  @Getter private activeProject: any;
  @Getter private activeProjectId!: number;
  @Getter private roles: any;
  private isSaving: boolean = false;
  private inviteResent: boolean = false;
  private rolesSelected: any[] = [];

  public async mounted() {
    await this.addRolesAsync();
    this.rolesSelected = this.roles.filter((r: any) => {
      if (this.user.roles && this.user.roles.includes(r.name)) {
        return r;
      }
    });
  }

  private async saveUser() {
    if (this.rolesSelected.length) {
      this.isSaving = true;

      try {
        const data = {
          user: {
            email: this.user.email,
          },
          roles: this.rolesSelected,
        };
        const response = this.user.id
          ? await UserService.updateUser(Number(this.user.id), data)
          : await UserService.createUser(data);

        this.$emit('update:users');
        this.$emit('close');
      } finally {
        this.isSaving = false;
      }
    } else {
      this.addToastErrorMessage('You must select at least one role to save this user.');
    }
  }

  private async resendPassword() {
    await UserService.resendPassword(this.user.id);
    this.inviteResent = true;
  }

  private getColor(role: any) {
    switch (role) {
      case 'Super Admin': return 'rgba(1,110,161,0.6)';
      case 'Organisation Admin': return '#016EA1';
      case 'User': return 'rgba(1,110,161,0.4)';
      default: return 'primary';
    }
  }

  get email() {
    return this.user.email;
  }

  set email(email: string) {
    this.user.email = email.toLowerCase();
  }
}
